import { SERIALIZED_AGENCY_TYPES } from '../../helpers/ShippingOptionHelper';

class ShippingOptionSerializer {
  static deSerialize(data) {
    const deSerializedData = [];
    data.forEach((dataLine) => {
      const genericData = {
        acceptedPaymentMethods: dataLine.FormasDePago.indexOf(4) === -1 ?
          dataLine.FormasDePago.concat(4) :
          dataLine.FormasDePago,
        price: dataLine.CostoFlete,
        shippingType: dataLine.TipoFlete,
      };
      genericData.acceptedPaymentMethods.push(6);
      if (dataLine.EsEspecial && !dataLine.AgenciasTransporte) {
        deSerializedData.push({
          ...genericData,
          timeSlots: dataLine.FechaHorario.map(timeSlot => ({
            date: timeSlot.Fecha,
            startHour: timeSlot.HoraInicio,
            endHour: timeSlot.HoraFin,
          })),
        });
      } else if (dataLine.AgenciasTransporte) {
        const busAgencyData = dataLine.AgenciasTransporte.filter(agency => (
          agency.TipoAgenciaID === SERIALIZED_AGENCY_TYPES.BUS
        ));
        if (busAgencyData.length) {
          deSerializedData.push({
            ...genericData,
            name: busAgencyData[0].TipoAgenciaNombre,
            agencies: busAgencyData.map(agency => ({
              extraCost: agency.ValorPiso,
              id: agency.Agencia,
              name: agency.Nombre,
            })),
            timeSlots: dataLine.FechaHorario.map(timeSlot => ({
              date: timeSlot.Fecha,
              startHour: timeSlot.HoraInicio,
              endHour: timeSlot.HoraFin,
            })),
          });
        }
        const truckAgencyData = dataLine.AgenciasTransporte.filter(agency => (
          agency.TipoAgenciaID === SERIALIZED_AGENCY_TYPES.TRUCK
        ));
        if (truckAgencyData.length) {
          deSerializedData.push({
            ...genericData,
            name: truckAgencyData[0].TipoAgenciaNombre,
            agencies: truckAgencyData.map(agency => ({
              extraCost: agency.ValorPiso,
              id: agency.Agencia,
              name: agency.Nombre,
            })),
            timeSlots: dataLine.FechaHorario.map(timeSlot => ({
              date: timeSlot.Fecha,
              startHour: timeSlot.HoraInicio,
              endHour: timeSlot.HoraFin,
            })),
          });
        }
      } else {
        dataLine.FechaHorario.forEach((timeSlot) => {
          deSerializedData.push({
            ...genericData,
            date: timeSlot.Fecha,
            startHour: timeSlot.HoraInicio,
            endHour: timeSlot.HoraFin,
          });
        });
      }
    });
    return deSerializedData;
  }
}

export { ShippingOptionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ShippingOptionSerializer.js